import { FlowAPI, MeetingsAPI, RoutingAPI, WidgetCacheAPI } from 'api'

export const getMeetingsStatus = () =>
  MeetingsAPI.get('/calendar/properties/status/v3')

export const getBulkCalendarStatus = (orgId) =>
  MeetingsAPI.get(`/calendar/properties/organizations/${orgId}/state`)

export const disconnectMicrosoftBulkCalendar = () =>
  MeetingsAPI.post('microsoft/organization/calendar/disconnect')

export const disconnectGoogleBulkCalendar = () =>
  MeetingsAPI.post('google/organization/calendar/disconnect')

export const checkGoogleBulkCalendarStatus = () =>
  MeetingsAPI.post('/google/organization/calendar/connect')

export const enableIndividualBulkCalendar = () =>
  MeetingsAPI.post('/calendar/properties/reconnect')

export const getGoogleCalendars = () =>
  MeetingsAPI.get('/google/calendar/calendars')

export const getMicrosoftCalendars = () =>
  MeetingsAPI.get('/microsoft/calendar/calendars')

export const updateGoogleCalendar = (calendar) =>
  MeetingsAPI.post('/google/calendar/calendars/choose', calendar)

export const updateMicrosoftCalendar = (calendar) =>
  MeetingsAPI.post('/microsoft/calendar/calendars/choose', calendar)

export const setOutOfOfficeTime = (time) =>
  MeetingsAPI.post('/calendar/properties/update_ooo', time)

export const disconnectGoogleCalendar = () =>
  MeetingsAPI.post('/google/calendar/disconnect')

export const disconnectMicrosoftCalendar = () =>
  MeetingsAPI.post('/microsoft/calendar/disconnect')

export const getDefaultMeetingType = () =>
  MeetingsAPI.get('/scheduling/settings')

export const saveCalSettings = (settings) =>
  MeetingsAPI.put('/scheduling/settings', settings)

export const getOrgCalendarSettings = async (orgId) =>
  MeetingsAPI.get(`/calendar/properties/organizations/${orgId}`)

const mapInSlug = (types) =>
  Object.entries(types).reduce((accumulator, [slug, meetingType]) => {
    const meetingTypeWithSlug = { ...meetingType, slug }
    accumulator.push(meetingTypeWithSlug)
    return accumulator
  }, [])

export const getCustomMeetingTypes = async () => {
  const { data: customMeetings } = await MeetingsAPI.get(
    '/scheduling/settings/custom/v2'
  )
  return Promise.resolve(mapInSlug(customMeetings))
}

export const getOrgMeetingTypes = async (orgId) => {
  const { data: customMeetings } = await MeetingsAPI.get(
    `/scheduling/settings/organizations/${orgId}`
  )
  return Promise.resolve(mapInSlug(customMeetings))
}

export const getPlaybooksWithOrgMeeting = (meetingSlug) =>
  FlowAPI.get(`interactions/find_by_meeting/${meetingSlug}`)

export const getRoutingRulesWithOrgMeeting = (meetingSlug) =>
  RoutingAPI.get(`/rules/by_meeting/${meetingSlug}`)

export const updateMeetingSettings = (newMeetingType) => {
  const queryPayload = newMeetingType.oldSlug
    ? `?oldSlug=${newMeetingType.oldSlug}`
    : ''
  const url = `/scheduling/settings${
    newMeetingType.slug ? `/custom/${newMeetingType.slug}` : ''
  }${queryPayload}`

  return MeetingsAPI.put(url, newMeetingType)
}

export const getCalendarConnectedUsers = () =>
  MeetingsAPI.get('/scheduling/settings/connected')

export const saveNewMeetingType = ({
  meetingTemplate,
  id,
  slug,
  isOrgMeeting,
}) =>
  MeetingsAPI.post(
    `/scheduling/settings/${
      isOrgMeeting ? 'organizations' : 'custom'
    }/${id}/${slug}`,
    meetingTemplate
  )

export const updateMeetingType = ({
  meetingTemplate,
  id,
  slug,
  oldSlug,
  isOrgMeeting,
}) => {
  const orgPathFragment = isOrgMeeting ? 'organizations' : 'custom'
  if (slug !== oldSlug) {
    return MeetingsAPI.post(
      `/scheduling/settings/${orgPathFragment}/${id}/${slug}?oldSlug=${oldSlug}`,
      meetingTemplate
    )
  }
  return MeetingsAPI.post(
    `/scheduling/settings/${orgPathFragment}/${id}/${slug}`,
    meetingTemplate
  )
}

export const updateOrgCalendarSettings = (prioritizeFairness, orgId) => {
  return MeetingsAPI.post(`/calendar/properties/organizations/${orgId}`, {
    prioritizeFairness,
  })
}

export const getTaskConfig = () => MeetingsAPI.get('/assistant/settings/agent')

export const setTaskConfig = (payload) =>
  MeetingsAPI.patch('/assistant/settings/agent', payload)

export const sendTestAssistantEmail = (taskType) =>
  MeetingsAPI.post('/assistant/settings/test_email', taskType)

export const connectDefaultCalendar = (calendarProvider, userId) =>
  MeetingsAPI.post(
    `/${calendarProvider}/calendar/${userId}/calendars/choose/primary`
  )

export const getPersonalizationTags = (isOrgMeeting) =>
  MeetingsAPI.get(
    `/assistant/settings/email_context?isOrgMeeting=${isOrgMeeting}`
  )

export const getMeetingsPersonalizationTags = () =>
  MeetingsAPI.get('/scheduling/settings/invitation_context')

export const deleteMeetingType = (slug) =>
  MeetingsAPI.delete(`/scheduling/settings/custom/${slug}`)

export const deleteOrgMeetingType = (orgId, slug) =>
  MeetingsAPI.delete(`/scheduling/settings/organizations/${orgId}/${slug}`)

export const isZoomOauthed = () => {
  return MeetingsAPI.get('/zoom/connected')
}

export const getZoomUser = () => {
  return MeetingsAPI.get('/zoom/user')
}

export const disconnectZoom = () => {
  return MeetingsAPI.post('/zoom/disconnect')
}

export const disconnectMicrosoftTeams = () => {
  return MeetingsAPI.post('/microsoft_teams/disconnect')
}

export const fetchMultiEmbedsLocales = () => {
  return WidgetCacheAPI.get('/child_embeds/enabledLanguages')
}
